import Criteria from './Criteria'

export default class TaskFields extends Criteria{

  getProperties() {
    return [
      {cac_descricao: 'Observação', cac_codigo: 'observation'}
    ]
  }
}